import React, { useState, useEffect } from 'react';

import SellConfirm from './SellConfirm';
import TransactionCommonModal from '../../common/TransactionCommonModal';
import SellCurrencyForm from './SellCurrencyForm';

const SellModal = ({
    formData,
    quotationData,
    onClickCall,
    isLoading,
    exchangeLoading,
    isConfirmModal,
    setIsConfirmModal,
    amountError,
    handleAmountChange,
    handleAmountAndSetFormData,
    setFormData,
    selectedCryptoCurrency,
    setSelectedCryptoCurrency,
    selectedFiatCurrency,
    setSelectedFiatCurrency,
    exchangeRate,
    isOpen,
    handleConfirmationModal,
    onClose,
    handleModalAction,
    setQuotationData,
    quotationError,
    modalTimerRef,
}) => {
    const handleBack = () => {
        setIsConfirmModal(false);
        setQuotationData({});
        clearTimeout(modalTimerRef.current);
    };

    return (
        <TransactionCommonModal
            open={isOpen}
            onClose={() => {
                onClose();
                handleModalAction?.();
            }}
            onBack={handleBack}
            heading={!isConfirmModal ? 'SELL CRYPTO' : 'SELL CONFIRMATION'}
            bottomButtonText={!isConfirmModal ? 'CONTINUE' : isLoading ? 'Processing' : 'SELL NOW'}
            onBottomButtonClick={!isConfirmModal ? handleConfirmationModal : onClickCall}
            showBackButton={isConfirmModal}
            showCloseIcon={true}
            loading={isLoading}
            disabled={
                // isLoading ||
                (isConfirmModal &&
                    (!quotationData ||
                        Object.keys(quotationData).length === 0 ||
                        quotationData.error)) ||
                !formData.cryptoAmount ||
                !formData.fiatAmount ||
                amountError
            }>
            {!isConfirmModal ? (
                <SellCurrencyForm
                    formData={formData}
                    amountError={amountError}
                    handleAmountChange={handleAmountChange}
                    handleAmountAndSetFormData={handleAmountAndSetFormData}
                    setFormData={setFormData}
                    selectedCryptoCurrency={selectedCryptoCurrency}
                    setSelectedCryptoCurrency={setSelectedCryptoCurrency}
                    selectedFiatCurrency={selectedFiatCurrency}
                    setSelectedFiatCurrency={setSelectedFiatCurrency}
                    exchangeLoading={exchangeLoading}
                    exchangeRate={exchangeRate}
                    quotationError={quotationError}
                />
            ) : (
                <SellConfirm
                    formData={formData}
                    quotationData={quotationData}
                    exchangeLoading={exchangeLoading}
                />
            )}
        </TransactionCommonModal>
    );
};

export default SellModal;
